import React, { useState } from "react";
import { Button, Card, Empty, Timeline } from "antd";
import dayjs from "dayjs";

const Logs = ({ title, styles = {}, is_loading = false, data = [] }) => {
  const [show, setShowed] = useState(false);

  const header_styles = !show
    ? { ...styles.header, border: "none" }
    : { ...styles.header };

  const body_styles = !show
    ? { ...styles.body, padding: 0 }
    : { ...styles.body };

  return (
    <Card
      title={title}
      styles={{
        ...styles,
        header: header_styles,
        body: body_styles,
      }}
      loading={is_loading}
      extra={
        <Button
          htmlType="button"
          type="primary"
          onClick={() => setShowed(!show)}
        >
          {show ? "Ukryj" : "Pokaż"}
        </Button>
      }
    >
      {show &&
        (data?.length > 0 ? (
          <Timeline
            style={{ maxWidth: "90%", margin: "0 auto" }}
            mode="left"
            items={data
              ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
              ?.map(({ content, is_important, user, created_at }) => ({
                color: is_important ? "red" : "blue",
                label: created_at
                  ? dayjs(created_at).format("DD-MM-YYYY HH:mm")
                  : "-",
                children: (
                  <>
                    <strong>{user?.full_name || "-"}</strong>
                    <p>{content}</p>
                  </>
                ),
              }))}
          />
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Brak danych"
          />
        ))}
    </Card>
  );
};

export default Logs;
